import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import { Tab } from "@pentabd/ui";

import { ErrorModal, SuccessModal } from "@components";
import { Building, Desk, Office, Room, RoomType } from "./components";
import RoomConfigHeader from "./components/RoomConfigHeader";

const RoomConfiguration = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const scrollToTopRef = useRef<any>(null);

  const [errorMessage, setErrorMessage] = useState("");

  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
  };
  const closeErrorModal = () => setIsErrorModalOpen(false);

  const { t } = useTranslation();

  useEffect(() => {
    const reset = () => {
      setIsErrorModalOpen(false);
      setIsSuccessModalOpen(false);
      setErrorMessage("");
    };
    return reset();
  }, []);
  const handleScrollToTop = () => {
    if (scrollToTopRef.current) {
      scrollToTopRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const tabData = [
    {
      label: t("INVENTORY_ROOM_CONFIG.TABS.OFFICE"),
      component: <Office />,
    },
    {
      label: t("INVENTORY_ROOM_CONFIG.TABS.BUILDING"),
      component: (
        <Building
          setIsErrorModalOpen={setIsErrorModalOpen}
          setIsSuccessModalOpen={setIsSuccessModalOpen}
          setErrorMessage={setErrorMessage}
          handleScrollToTop={handleScrollToTop}
        />
      ),
    },
    {
      label: t("INVENTORY_ROOM_CONFIG.TABS.ROOM_TYPE"),
      component: (
        <RoomType
          setIsErrorModalOpen={setIsErrorModalOpen}
          setIsSuccessModalOpen={setIsSuccessModalOpen}
          setErrorMessage={setErrorMessage}
          handleScrollToTop={handleScrollToTop}
        />
      ),
    },
    {
      label: t("INVENTORY_ROOM_CONFIG.TABS.ROOM"),
      component: (
        <Room
          setIsErrorModalOpen={setIsErrorModalOpen}
          setIsSuccessModalOpen={setIsSuccessModalOpen}
          setErrorMessage={setErrorMessage}
          handleScrollToTop={handleScrollToTop}
        />
      ),
    },
    {
      label: t("INVENTORY_ROOM_CONFIG.TABS.DESK"),
      component: (
        <Desk
          setIsErrorModalOpen={setIsErrorModalOpen}
          setIsSuccessModalOpen={setIsSuccessModalOpen}
          setErrorMessage={setErrorMessage}
          handleScrollToTop={handleScrollToTop}
        />
      ),
    },
  ];

  return (
    <div className="container p-10" ref={scrollToTopRef}>
      <SuccessModal
        isModalOpen={isSuccessModalOpen}
        action={closeSuccessModal}
      />
      <ErrorModal
        subtitle={errorMessage}
        isModalOpen={isErrorModalOpen}
        closeModal={closeErrorModal}
      />
      <RoomConfigHeader />
      <Tab active={activeTab} setActiveTab={setActiveTab} className="mt-10">
        <Tab.Heads>
          {tabData.map(({ label }, i) => (
            <Tab.Item key={i} index={i} label={label} />
          ))}
        </Tab.Heads>
        <Tab.ContentWrapper>
          {tabData.map(({ component }, i) => (
            <Tab.Content key={i} index={i}>
              {component}
            </Tab.Content>
          ))}
        </Tab.ContentWrapper>
      </Tab>
    </div>
  );
};

export default RoomConfiguration;
